// Pendências para emitir. A lista vem do backend (POST /nfe/pendencias, ou o
// 400 {codigo: 'pendencias_emissao'} do /emitir e da prévia); aqui só se
// agrupa e se decide para onde o botão "Corrigir" leva. Nenhuma regra fiscal
// mora no navegador.

export const CODIGO_PENDENCIAS = 'pendencias_emissao';

// { operador: [...], escritorio: [...] } — na ordem em que vieram.
export function agruparPendencias(lista) {
  const grupos = { operador: [], escritorio: [] };
  (lista || []).forEach(p => {
    (p?.quem_resolve === 'operador' ? grupos.operador : grupos.escritorio).push(p);
  });
  return grupos;
}

// Erro de uma chamada (api.request / api.previewDanfe) que traz a lista.
export function pendenciasDoErro(err) {
  const dados = err?.dados || {};
  return dados.codigo === CODIGO_PENDENCIAS && Array.isArray(dados.pendencias)
    ? dados.pendencias : null;
}

// Aba de tributo do item onde fica o campo (abas da tela de emissão).
export function abaDoCampo(campo) {
  if (campo === 'cst_pis' || campo === 'aliquota_pis') return 'pis';
  if (campo === 'cst_cofins' || campo === 'aliquota_cofins') return 'cofins';
  if (campo === 'cst_ipi' || campo === 'aliquota_ipi') return 'ipi';
  if (campo === 'cst_icms' || campo === 'valor_icms_st') return 'icms';
  return null;
}

// Para onde "Corrigir" leva:
//   { tipo: 'item', indice, aba }       — passo Itens, no item e na aba certos
//   { tipo: 'etapa', etapa }            — passo da própria nota (consumidor final, referências)
//   { tipo: 'pagina', pagina, payload } — cadastro já existente (produto/empresa)
//   null                                — não há o que abrir (só o escritório)
export function destinoCorrecao(p, { isAdmin = false, empresaId = null } = {}) {
  if (!p || !p.acao) return null;
  if (p.acao === 'editar_item' && p.item) {
    return { tipo: 'item', indice: p.item - 1, aba: abaDoCampo(p.campo) };
  }
  if (p.acao === 'editar_produto' && p.produto_id) {
    // Classificação IBS/CBS é do escritório: o operador não altera o cClassTrib,
    // então o cadastro do produto não resolve a pendência para ele.
    if (p.quem_resolve === 'escritorio' && !isAdmin) return null;
    return { tipo: 'pagina', pagina: 'produtos', payload: { editarProdutoId: p.produto_id } };
  }
  if (p.acao === 'cadastrar_produto') {
    return { tipo: 'pagina', pagina: 'produtos',
      payload: { novoProduto: { codigo: p.codigo_produto || '', descricao: p.descricao || '' } } };
  }
  if (p.acao === 'editar_referencias') {
    // Notas referenciadas da nota inteira (rejeição 679): ficam no passo "Emissão".
    return { tipo: 'etapa', etapa: 6 };
  }
  if (p.acao === 'escolher_consumidor_final') {
    // Consumidor final (F0h): a escolha fica no passo "Dados Cliente" da nota.
    return { tipo: 'etapa', etapa: 2 };
  }
  if (p.acao === 'editar_empresa') {
    // Certificado: abre direto a janela de envio do certificado.
    const abrirCertificado = String(p.tipo || '').startsWith('certificado');
    return isAdmin && empresaId
      ? { tipo: 'pagina', pagina: 'empresas', payload: { editarEmpresaId: empresaId, abrirCertificado } }
      : { tipo: 'pagina', pagina: 'minha_empresa', payload: { abrirCertificado } };
  }
  return null;
}

// Item da lista com a sugestão aplicável no próprio item (código padrão do
// regime/empresa, NCM do cadastro). A troca só acontece no clique do operador.
export function sugestaoAplicavel(p) {
  return !!(p && p.acao === 'editar_item' && p.item && p.sugestao && p.campo
    && ['cst_icms', 'ncm'].includes(p.campo));
}
